/*
x表示当地的纬度lat,y表示当地的经度lng
lng: 经度0°——180°（东行,标注E）0°——180°（西行,标注W）
lat: 纬度0°——90°N、0°——90°S
*/
// 默认定位城市，根据项目需求修改城市和默认坐标
let currentProvince = '广东省'
let currentCity = '广州市'
let currentCityCenterLng = '113.2714290000' // 经度, ,
let currentCityCenterLat = '23.1353360000' // 纬度
export default {
  convertPointCount: 10, // 百度地图坐标系一次转换的最大坐标点个数，取值范围1-10
  getDefaultCityPoint: () => {
    return {
      province: currentProvince,
      city: currentCity,
      lat: currentCityCenterLat,
      lng: currentCityCenterLng
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/business/map/MapUtils.js